import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api, auth } from '../lib/api';
import { useAsync } from '../lib/useAsync';

export function Orgs() {
  const orgs = useAsync(() => api.orgs.list(), []);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ slug: '', name: '', emailFrom: '', allowedOrigins: '' });
  const [error, setError] = useState('');
  const isAdmin = auth.session!.staff.isPlatformAdmin;

  async function create(e: FormEvent) {
    e.preventDefault();
    setError('');
    try {
      await api.orgs.create({ ...form, allowedOrigins: form.allowedOrigins.split(/[\s,]+/).filter(Boolean) });
      setCreating(false);
      setForm({ slug: '', name: '', emailFrom: '', allowedOrigins: '' });
      orgs.reload();
    } catch (err) { setError((err as Error).message); }
  }

  return (
    <>
      <div className="row between"><h1>Orgs</h1>{isAdmin && <button className="primary" onClick={() => setCreating((v) => !v)}>{creating ? 'Cancel' : 'New org'}</button>}</div>
      {creating && (
        <form onSubmit={create} className="card stack" style={{ marginBottom: '1rem' }}>
          <div className="row">
            <div style={{ flex: 1 }}><label>Slug</label><input required value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} placeholder="haas" /></div>
            <div style={{ flex: 2 }}><label>Name</label><input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="TGR Haas F1 Team" /></div>
          </div>
          <div><label>Email from</label><input required value={form.emailFrom} onChange={(e) => setForm({ ...form, emailFrom: e.target.value })} placeholder="TGR Haas F1 Team <fans@mmtestsystem.com>" /></div>
          <div><label>Allowed origins (one per line)</label><textarea rows={3} value={form.allowedOrigins} onChange={(e) => setForm({ ...form, allowedOrigins: e.target.value })} placeholder="https://tgrhaas.mmtestsystem.com" /></div>
          <div className="row"><button className="primary">Create</button>{error && <span className="err">{error}</span>}</div>
        </form>
      )}
      {orgs.error && <p className="err">{orgs.error}</p>}
      {orgs.data && orgs.data.length === 0 && <div className="empty">No orgs yet.</div>}
      {orgs.data && orgs.data.length > 0 && (
        <table>
          <thead><tr><th>Org</th><th>Slug</th><th>Publishable key</th><th>Origins</th></tr></thead>
          <tbody>
            {orgs.data.map((o) => (
              <tr key={o.id}>
                <td><Link to={`/orgs/${o.id}`}><b>{o.name}</b></Link></td>
                <td>{o.slug}</td>
                <td><code>{o.publishableKey}</code></td>
                <td className="muted">{o.allowedOrigins.join(', ') || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
